// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 11/10/2023
 */

 .ServicesIntro_outerContainer__6\\+v7D {
    display: flex;
    align-items: flex-end;
  }
  
.ServicesIntro_textContainer__24zn6 {
    height: 100%;
    position: relative;
    padding: 130px; 
    left: -100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.8), rgb(255, 255, 255, 0.0)); 
    
}

.ServicesIntro_topic__c\\+45e {
    /* font-family: Poppins; */
    font-size: 3rem;
    font-style: normal;
    font-weight: 600;
    margin: 0;
}

.ServicesIntro_description__TqW03 {
    width: 30rem;
    margin: 1rem 0 2rem 0;
    padding: 0 12rem 0 0;
}

/* mobile */
@media (max-width: 770px) {
    .ServicesIntro_textContainer__24zn6 {
        height: 100%;
        position: relative;
        padding: 10px;
    }

    .ServicesIntro_topic__c\\+45e {
        font-size: 2rem;
    }

    .ServicesIntro_mainImage__vvYCw {
        /* display: none; */
        position: relative;
        width: 100%;
        height: auto;
    }

    .ServicesIntro_description__TqW03 {
        width: 20rem;
        padding: 0;
        margin: 1rem 0;
    }
}

@media (min-width: 701px) {
    .ServicesIntro_mainImage__vvYCw {
        max-width: 100%;
        height: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/services/ServicesIntro.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;CAED;IACG,aAAa;IACb,qBAAqB;EACvB;;AAEF;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,wFAAwF;;AAE5F;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA,WAAW;AACX;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;IAChB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 11/10/2023\r\n */\r\n\r\n .outerContainer {\r\n    display: flex;\r\n    align-items: flex-end;\r\n  }\r\n  \r\n.textContainer {\r\n    height: 100%;\r\n    position: relative;\r\n    padding: 130px; \r\n    left: -100%;\r\n    background: linear-gradient(to right, rgba(255, 255, 255, 0.8), rgb(255, 255, 255, 0.0)); \r\n    \r\n}\r\n\r\n.topic {\r\n    /* font-family: Poppins; */\r\n    font-size: 3rem;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    margin: 0;\r\n}\r\n\r\n.description {\r\n    width: 30rem;\r\n    margin: 1rem 0 2rem 0;\r\n    padding: 0 12rem 0 0;\r\n}\r\n\r\n/* mobile */\r\n@media (max-width: 770px) {\r\n    .textContainer {\r\n        height: 100%;\r\n        position: relative;\r\n        padding: 10px;\r\n    }\r\n\r\n    .topic {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .mainImage {\r\n        /* display: none; */\r\n        position: relative;\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    .description {\r\n        width: 20rem;\r\n        padding: 0;\r\n        margin: 1rem 0;\r\n    }\r\n}\r\n\r\n@media (min-width: 701px) {\r\n    .mainImage {\r\n        max-width: 100%;\r\n        height: auto;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerContainer": `ServicesIntro_outerContainer__6+v7D`,
	"textContainer": `ServicesIntro_textContainer__24zn6`,
	"topic": `ServicesIntro_topic__c+45e`,
	"description": `ServicesIntro_description__TqW03`,
	"mainImage": `ServicesIntro_mainImage__vvYCw`
};
export default ___CSS_LOADER_EXPORT___;
